'use strict';

var compact = require('mdast-util-compact');

module.exports = compile;

/* Stringify the given tree. */
function compile() {
  return this.visit(compact(this.tree, this.options.commonmark));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/macro/compile.js
// module id = 952
// module chunks = 95715928098905 168707334958949